export default {
  CONFIRM_ALERT_DELETE_MSG: 'Are you sure want to delete it?',
  CONFIRM_ALERT_RESET_PWD_MSG: 'Are you sure want to reset password?',
  CONFIRM_ALERT_STOP_STRIPE_PAYMENT_MSG: 'Are you sure want to stop stripe payment?',
  CONFIRM_ALERT_START_STRIPE_PAYMENT_MSG: 'Are you sure want to start stripe payment?',
  CONFIRM_ALERT_SSO_MSG: 'Are you sure want to activate it?',
  HTTP_ERROR_MSG_500: 'Internal Server Error',
  PRODUCT_SUB_CANCEL_MSG: 'Your subscription will end after 2 months',
  ALERT_MSG_SUB: 'To access ChaliceFT products, you must first subscribe to a membership plan. Please click Ok, to go to the membership plan page where you will be able to personalize your membership plan',
  ALERT_MSG_SUB_ADD_PROD: 'To access ChaliceFT products, you must first subscribe to access. Please click Ok, to go to the additional product page where you will be able to personalize your product',
  CONFIRM_ALERT_CANCEL_MSG: 'Are you sure want to cancel product subscription?',
  CONFIRM_ALERT_RESUME_MSG: 'Are you sure want to resume product subscription?',
  MSG_SUBSCRIPTION_READONLY_USER: 'You are a read only user. You do not have a subscription.',
  MSG_SUBSCRIPTION_ADMIN: 'You are an Administrator. You do not have a subscription.',
  CONFIRM_ALERT_DELETE_MEMBERSHIP_PLAN: 'Are you sure want to delete this membership plan?',
  CONFIRM_ALERT_CANCEL_SUBSCRIPTION: 'Do you want to cancel your subscription?',
  CONFIRM_SIGNUP_TOKEN: 'Are you sure want to new signup token?',
  CONFIRM_DELETE_SSO_AUTH: 'Are you sure want to delete this SSO authenticate?',
  CONFIRM_DELETE_RSS_FEED: 'Are you sure want to delete this RSS feed?',
  CONFIRM_DELETE_ROLE: 'Are you sure want to delete this Role?',
  CONFIRM_DELETE_PRODUCT_TAG: 'Are you sure want to delete this product tag?',
  CONFIRM_DELETE_PRODUCT: 'Are you sure want to delete this product?',
  CONFIRM_HIDE_PRODUCT: 'Are you sure want to hide this product from exchange?',
  CONFIRM_SHOW_PRODUCT: 'Are you sure want to show this product on exchange?',
  CONFIRM_DELETE_BANNER: 'Are you sure want to delete this banner?',
  CONFIRM_DELETE_MEDIA: 'Are you sure want to delete this media?',
  CONFIRM_DELETE_PARTNER: 'Are you sure want to delete this partner?',
  CONFIRM_DELETE_PAGE: 'Are you sure want to delete this page?',
  CONFIRM_DELETE_EVENT: 'Are you sure want to delete this Event?',
  CONFIRM_DELETE_REVIEW: 'Are you sure want to delete this Review?',
  CONFIRM_DELETE_SURVEY: 'Are you sure want to delete this Survey Question?',
  CONFIRM_DELETE_FAQ: 'Are you sure want to delete this FAQ?',
  CONFIRM_DELETE_LEAD: 'Are you sure want to delete this Lead?'
}
